import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

// Public, unauthenticated fetch — bypasses the auth interceptor.
function fetchWins() {
  return fetch("/api/public/wins", { credentials: "omit" })
    .then((r) => (r.ok ? r.json() : []))
    .catch(() => []);
}

function relTime(iso) {
  if (!iso) return "";
  const now = Date.now();
  const then = new Date(iso).getTime();
  const diff = Math.max(0, (now - then) / 1000);
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

const POSSESSIVE = {
  first_goal_emergency_fund: "unlocked their Emergency Fund goal",
  first_goal_retirement: "hit a Retirement milestone",
  first_goal_vacation: "fully funded their Vacation goal",
  first_goal_investment: "met their Investment goal",
  first_goal_down_payment: "reached their Down Payment fund",
  first_goal_education: "funded their Education goal",
  first_goal_debt: "cleared a Debt payoff goal",
  first_goal_personal_development: "funded their Personal Development goal",
  first_green_month: "closed their first month in the green",
  first_4_week_streak: "hit a 4-week reflection streak",
};

function formatWin(row) {
  const verb = POSSESSIVE[row.milestone_id] || "unlocked a milestone";
  return `${row.first_name || "Someone"} ${verb}`;
}

export default function WinsTicker() {
  const [wins, setWins] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    fetchWins().then(setWins);
  }, []);

  useEffect(() => {
    if (wins.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % wins.length), 4200);
    return () => clearInterval(t);
  }, [wins.length]);

  if (!wins.length) return null;
  const w = wins[idx];
  return (
    <div
      className="border-y border-[#E6E3DB] bg-[#F7F5F0] py-3"
      data-testid="wins-ticker"
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center gap-3">
        <div className="shrink-0 h-7 w-7 rounded-full bg-[#C05C3D] flex items-center justify-center">
          <Sparkles className="h-3.5 w-3.5 text-white" />
        </div>
        <p
          key={w.created_at + w.milestone_id}
          className="text-sm text-[#4d4f4c] truncate animate-fadein"
          data-testid="wins-ticker-item"
        >
          <span className="font-medium text-[#2C302E]">{formatWin(w)}</span>
          <span className="text-[#787671] ml-2">· {relTime(w.created_at)}</span>
        </p>
      </div>
    </div>
  );
}
